import React, { useEffect, useState } from "react";
import { Row, Col, Comment, Avatar, Skeleton, Empty, notification } from "antd";
import "./EmployerProfile.css";
import Stars from "../../../assets/icons/Star233x.png";
import NoJobImage from "../../../assets/img/employeeprofile_nojobimg.png";
import { useDispatch, useSelector } from "react-redux";
import Cards from "./components/dashboardCards/cards";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import JobCard from "../../../components/JobCard/JobCard";
import InterviewCard from "./components/interviewCard/InterviewCard";
import TalentCards from "./components/TalentCards/TalentCards";
import { getImageByStateCode } from "../../CompanyProfile/components/cloudinary";
import candidate_img from "../../../assets/img/becomeACandidate.png";
import { Image } from "antd";
import {
  getDashboardDetails,
  getCompanyProfileDetails,
  getDashboardInterview,
  getDashboardMatches,
  fetchUserProfile,
  getReminders,
  resetUpdateNotes,
  getGigRoles,
  wizardFinished,
  getConversationCountInit,
  candidateDetailInit,
} from "../../../redux/actions";
import history from "../../../routes/history";
import Loader from "../../../components/Loading/Loader";
import TopAlert from "../../../components/TopNotification/TopAlert";
import WS from "../../../webSocket/defaultSocket";
import noJobs from "../../../assets/img/EmptyInterviews1.png";
import RateCandidateSessionModal from "../../Conversations/components/ChatCard/components/RatingsCard/component/RateCandidateSessionModal";
import Reminders from "../../ProfileDetail/Notes/reminders";
import { fetchToken } from "../../../API/API";
import axios from "axios";
import { getCompanyName, setCookie } from "../../../shared/helpers";
import ErrorModal from "../../../components/ErrorModal/errormodal";
import { DefaultRating } from "../../../assets/helpers";
import { Alert } from "antd";
import { Tooltip } from "antd";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import AbsTag from "../../../assets/icons/AbsTag.svg";
import AdminTag from "../../../assets/icons/AdminTag.svg";
import RequestedCards from "./components/RequestedCards/RequestedCards";
import candidate from "../../../assets/icons/candidate.svg";

const text = (
  <div
    style={{
      fontSize: "11px",
      fontWeight: "400",
    }}
  >
    Access to both your exclusive candidate pool and all candidates.
  </div>
);

const openNotification = () => {
  notification.open({
    message: "Gary has been added to your private marketplace",
    description: "An invitation has been sent on your behalf",
    icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
    style: {
      backgroundColor: "#52c41a",
      color: "white",
      border: "none",
    },
  });
};

const EmployerDashboard = () => {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [showAlert, setShowAlert] = useState(false);

  const showDisclaimer =
    JSON.parse(localStorage.getItem("showDisclaimer")) === null;

  const dispatch = useDispatch();
  // states from Reducers****************

  const authReducer = useSelector((state) => state.authReducer);

  const profile = useSelector((state) => state.profileReducer.user);
  const loading = useSelector((state) => state.profileReducer.loading);
  const details = useSelector((state) => state.dashbaordReducer.details);
  const matches = useSelector((state) => state.dashbaordReducer.matches);
  const interviews = useSelector((state) => state.dashbaordReducer.interviews);
  const Loading2 = useSelector((state) => state.dashbaordReducer.loading);
  const token = useSelector((state) => state.authReducer.user.authToken);
  const professionCode = useSelector(
    (state) => state.profileReducer.user?.profession?.ProfessionCode
  );
  const updateSuccess = useSelector(
    (state) => state.getProfileDetailsReducer.success
  );

  const { ABS } = useSelector((state) => state.profileReducer);
  const reminders = useSelector((state) => state.dashbaordReducer.reminders);
  //Hooks************************
  const [favoritesDp, setFavouriesDp] = React.useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [
    rateCandidateSessionModalVisible,
    setRateCandidateSessionModalVisible,
  ] = useState(true);
  const [starsR, setStarsR] = useState(DefaultRating);
  const [pendingRatings, setPendingRatings] = useState([]);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [APIerr, setAPIerr] = useState(false);
  const [errorMgs, setErrormsg] = useState("");

  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }

  useEffect(() => {
    setPendingRatings(details?.pendingRatings);
  }, [details?.pendingRatings]);
  useEffect(() => {
    setStarsR(
      profile.profile?.Rating === 0 ||
        profile.profile?.Rating === null ||
        profile.profile?.Rating === undefined
        ? DefaultRating
        : parseFloat(profile.profile?.Rating)
    );
  }, [profile.profile]);

  useEffect(() => {
    setCookie("finishProfile", "true");
    dispatch(getConversationCountInit());
    dispatch(getDashboardDetails());
    dispatch(getDashboardMatches());
    dispatch(getDashboardInterview());
    dispatch(getCompanyProfileDetails());
    dispatch(fetchUserProfile(token));
    dispatch(wizardFinished());
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (updateSuccess) {
      dispatch(getReminders());
      setTimeout(() => {
        dispatch(resetUpdateNotes());
      }, [2000]);
    }
  }, [updateSuccess]);
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(async () => {
    dispatch(getReminders());
    // dispatch(getGigRoles());
  }, []);

  axios.interceptors.response.use(
    (res) => {
      // Add configurations here
      return res;
    },
    (err) => {
      //  return Promise.reject(err);
      //  console.log('APIerr API failed', err);
      if (err) {
        setAPIerr(true);
        setErrormsg(err);
      }
    }
  );

  const currentUserEmail = localStorage.getItem("Email");
  const isAdmin = ABS.every((val) => val?.AMEmail !== "");
  const candidateName = localStorage.getItem("candidateName");
  useEffect(() => {
    if (candidateName) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        localStorage.removeItem("candidateName");
        setShowAlert(false);
      }, 7000);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      {candidateName ? (
        <Alert
          message={
            <div
              style={{ color: "white", fontSize: "16px", fontWeight: "500" }}
            >
              {candidateName} has been added to your private marketplace and an
              invitation has been sent on your behalf!
            </div>
          }
          type="success"
          showIcon
          closable
          onClose={() => localStorage.removeItem("candidateName")}
          style={{
            backgroundColor: "#118936",
            // borderColor: '#a6cda1',
            color: "#FFFFFF",
            fontWeight: "500",
            zIndex: "1111",
            top: "0",
            position: "fixed",
            width: "100%",
            border: "none",
            paddingLeft: windowDimensions.width > 786 ? "300px" : "",
            height: windowDimensions.width > 786 ? "60px" : "106px",
            fontSize: "16px",
          }}
          className="custom-alert"
        />
      ) : (
        ""
      )}
      {showDisclaimer && userProfile?.IsPrivateEmployer === true ? (
        <div className="div-main">
          <Alert
            className={
              windowDimensions.width > 700
                ? "disclaimer-web"
                : "disclaimer-mobile"
            }
            message={
              <div>
                <span className="private-div">PRIVATE</span>
                <span className="candidate-div">
                  {" "}
                  Access to both your exclusive candidate pool and all
                  candidates.
                </span>
              </div>
            }
            closable
            onClose={() => localStorage.setItem("showDisclaimer", "false")}
          />
        </div>
      ) : (
        ""
      )}
      {loading || Loading2 ? (
        <Loader />
      ) : (
        <div
          className={
            windowDimensions?.width > 700
              ? "employer-profile-container-parent-desktop"
              : "employer-profile-container-parent-mobile"
          }
        >
          {APIerr && (
            <ErrorModal
              isError={APIerr}
              message={errorMgs}
              setAPIerr={setAPIerr}
            />
          )}
          {pendingRatings?.length > 0 ? (
            <RateCandidateSessionModal
              ratingData={pendingRatings[0]}
              visible={rateCandidateSessionModalVisible}
              setVisible={setRateCandidateSessionModalVisible}
            />
          ) : null}

          <Row
            justify="space-between"
            className={
              windowDimensions.width > 700
                ? "employer-profile-container-parent-desktop-content-row"
                : "employer-profile-container-parent-mobile-content-row"
            }
          >
            <Col lg={7} xs={24} md={9}>
              <div className="employer-profile-container">
                <div
                  className="employer-profile-header"
                  style={{ marginBottom: "6%" }}
                >
                  {profile?.profile?.PictureUrl &&
                  profile?.profile?.PictureUrl?.split("/")?.pop() !==
                    "no-pic.png" ? (
                    <div className="employer-profile-header-left-image">
                      <img
                        className="display-picture"
                        src={`${process.env.REACT_APP_S3_URL}${
                          profile?.profile?.PictureUrl?.charAt(0) !== "/"
                            ? "/"
                            : ""
                        }${profile?.profile?.PictureUrl}`}
                        alt="profile_pic"
                        style={{ marginBottom: "10%" }}
                      />
                    </div>
                  ) : (
                    <div style={{ margin: "auto" }} className="">
                      <div
                        className="Avat"
                        style={{
                          width: "55px",
                          height: "55px",
                          fontSize: "24px",
                        }}
                      >
                        { getCompanyName(profile?.profile) ? getCompanyName(profile?.profile).charAt(0) : "C"}
                      </div>
                    </div>
                  )}
                  <div className="employer-profile-header-left-info">
                    <div className="employer-profile-header-left-info-name">
                      {getCompanyName(profile?.profile) ? getCompanyName(profile?.profile)
                        : capitalizeFirstLetter(userProfile.UserName)}
                      <div className="employer-profile-header-stars">
                        <img src={Stars} className="stars-img"></img>
                        <div className="stars-text">{starsR}</div>
                      </div>
                    </div>

                    {/* ////// */}
                    <div className="employer-profile-header-role">
                      {userProfile?.Profiles?.JobTitle
                        ? userProfile?.Profiles?.JobTitle
                        : "Role"}
                      {ABS?.length > 0 ? (
                        <img
                          src={isAdmin ? AdminTag : AbsTag}
                          style={{ padding: "0px 0px 3px 6px" }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {/* // */}

                    <div className="employer-profile-header-left-info-role">
                      {professionCode === "HC"
                        ? "Healthcare"
                        : professionCode === "IT"
                        ? "IT"
                        : "Healthcare"}
                    </div>
                    <div className="myClass">
                      {windowDimensions.width > 786 ? (
                        // If windows.length is greater than 786
                        userProfile?.IsPrivateEmployer === true ? (
                          <div style={{ display: "flex", padding: "5px 0px" }}>
                            <span
                              style={{
                                backgroundColor: "#0F1E2B",
                                fontWeight: "500",
                                fontSize: "12px",
                                lineHeight: "12px",
                                color: "white",
                                borderRadius: "2px",
                                padding: "2px 4px 2px 4px ",
                              }}
                            >
                              PRIVATE
                            </span>

                            <Tooltip
                              placement="right"
                              title={text}
                              overlayStyle={{
                                width: "210px",
                                height: "50px",
                                marginLeft: "12px",
                              }}
                              overlayInnerStyle={{
                                borderRadius: "6px",
                                padding: "6px 11px 10px 7px",
                                lineHeight: "17px",
                              }}
                            >
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                              >
                                <InfoCircleOutlined
                                  style={{
                                    color: "#7E7E7E",
                                    fontSize: "10px",
                                    marginLeft: "10px",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          </div>
                        ) : (
                          ""
                        )
                      ) : userProfile?.IsPrivateEmployer === true ? (
                        <div style={{ display: "flex", padding: "5px 0px" }}>
                          <span
                            style={{
                              // fontSize: "12px",

                              // fontWeight: "500",
                              backgroundColor: "#0F1E2B",
                              fontWeight: "500",
                              fontSize: "12px",
                              lineHeight: "12px",
                              color: "white",
                              borderRadius: "2px",
                              padding: "2px 4px 2px 4px ",
                            }}
                          >
                            PRIVATE
                          </span>

                          <Tooltip
                            placement="bottom"
                            title={text}
                            overlayStyle={{
                              width: "210px",
                              marginBlockEnd: "1px",
                            }}
                            overlayInnerStyle={{
                              borderRadius: "6px",
                              padding: "6px 11px 10px 7px",
                              lineHeight: "17px",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <InfoCircleOutlined
                                style={{
                                  color: "#7E7E7E",
                                  fontSize: "10px",
                                  marginLeft: "10px",
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {windowDimensions.width >= 768 && details?.myjobs?.gigs?.length ? (
              <Col lg={16} md={14} className="dashboard-banner">
                <div className="banner-inner-style">
                  <div className="dashboard-banner-text1">
                    Hiring made simple! Match, bid and hire!
                  </div>
                  <div className="dashboard-banner-text2">
                    Publish your open positions and start receiving bids from
                    our skilled talent marketplace!
                  </div>
                  <div className="postajob-btn-desktop-div">
                    <button
                      className="postajob-btn-desktop"
                      onClick={() => history.push("/postjob")}
                    >
                      <span className="postjobbtn_plussign">+</span>
                      <span className="postjobbtn_text">Post a gig</span>
                    </button>
                  </div>
                </div>
              </Col>
            ) : null}
          </Row>
          {!details && windowDimensions.width < 768 ? (
            <Col>
              <div className="employer-profile-body">
                <div className="employer-profile-body-content">
                  <img className="nojobimage" src={noJobs} />
                  <div className="nojobtext">
                    Create a gig to let candidates know you're hiring!
                  </div>
                  <button
                    className="postajob-btn"
                    onClick={() => history.push("/postjob")}
                  >
                    <span className="postjobbtn_plussign">+</span>
                    <span className="postjobbtn_text">Post a gig</span>
                  </button>
                </div>
              </div>
            </Col>
          ) : null}

          {windowDimensions.width < 768 && details?.myjobs?.gigs?.length ? (
            <div className="postajob-btn-div">
              <button
                className="postajob-btn"
                onClick={() => history.push("/postjob")}
              >
                <span className="postjobbtn_plussign">+</span>
                <span className="postjobbtn_text">Post a gig</span>
              </button>
            </div>
          ) : null}
          <div className="Add-candidate">
            <div className="candidate-text">
              Effortless Talent Management with SkillGigs!
            </div>
            <div className="candidate-subtext">
              Add candidates, track progress, and simplify your hiring process
              <button
                className="candidate-btn"
                onClick={() => {
                  dispatch(candidateDetailInit());
                  // history.push("/addCandidateEmail");
                  history.push({
                    pathname: "/add-candidate-email",})
                  localStorage.removeItem("persist:root");
                }}
              >
                <div>
                  <img src={candidate} />
                </div>
                <div className="candidate-btn-text"> Add candidate</div>
              </button>
            </div>
          </div>
          {/* This is for request sent */}

          {details?.invitedTalents && (
            <Cards
              heading={"Request Sent"}
              count={details?.invitedTalents[0]?.totalCount || "0"}
              goto={`/inviteTalents`}
            >
              <Row
                className={
                  details?.associatedTalents?.associatedTalentProfiles?.length >
                    0 && "candidate-card-row"
                }
              >
                {details?.invitedTalents[0]?.data?.length > 0 ? (
                  details?.invitedTalents[0]?.data?.map((items, index) => {
                    return (
                      <Col
                        key={index}
                        className={
                          windowDimensions.width < 768
                            ? "candidate-card-column-mobile"
                            : "candidate-card-column"
                        }
                      >
                        <RequestedCards
                          {...items}
                          isInvitation={true}
                          items={items}
                          pictureUrl={items?.users?.Profiles?.PictureUrl}
                          Rating={items?.users?.Profiles?.Rating}
                          Title={items?.Title}
                          ClientRate={items?.ClientRate}
                          Experience={
                            items?.users?.Profiles?.ExperienceLevelName
                              ?.YearsOfExperienceName
                          }
                          Minimumbid={items?.MinimumBid}
                          BudgetName={items?.BudgetTypes?.BudgetTypeName}
                          isInvitedTalent={true}
                          EmployerEmail={items?.InvitedBy[0]?.EmployerEmail}
                          EmployerName={items?.InvitedBy[0]?.EmployerName}
                          InvitedDate={items?.InvitedBy[0]?.InviteDate}
                        />
                      </Col>
                    );
                  })
                ) : (
                  <Col
                    xs={24}
                    style={{
                      padding: "10px",
                      textAlign: "left",
                      color: "#7E7E7E",
                      paddingLeft: "23px",
                      fontSize: "16px",
                    }}
                  >
                    <div></div>
                  </Col>
                )}
              </Row>
            </Cards>
          )}
          {/* This is for private candidates */}
          {userProfile?.IsPrivateEmployer && (
            <Cards
              heading={"Private candidates"}
              count={details?.associatedTalents?.count || "0"}
              goto={`/query?isPrivate=true`}
            >
              <Row
                className={
                  details?.associatedTalents?.associatedTalentProfiles?.length >
                    0 && "candidate-card-row"
                }
              >
                {details?.associatedTalents?.associatedTalentProfiles?.length >
                0 ? (
                  details?.associatedTalents?.associatedTalentProfiles?.map(
                    (items, index) => {
                      return windowDimensions.width < 768 &&
                        index > 1 ? null : (
                        <Col
                          key={index}
                          className={
                            windowDimensions.width < 768
                              ? "candidate-card-column-mobile"
                              : "candidate-card-column"
                          }
                        >
                          <TalentCards
                            isPrivate={userProfile?.IsPrivateEmployer}
                            {...items}
                            professionCode={professionCode}
                            data={items}
                            ClientRate={
                              items?.skill_listings?.ClientRate
                                ?.$numberDecimal ??
                              items?.skill_listings?.ClientRate ??
                              items?.ClientRate?.$numberDecimal ??
                              items?.ClientRate
                            }
                            users={items?.users}
                            UserName={`${items?.users?.Profiles?.FirstName}' '${items?.users?.Profiles?.LastName}`}
                            title={items?.skill_listings?.Title}
                            Experience={
                              items?.users?.Profiles?.YearsOfExperience
                                ?.YearsOfExperienceName
                            }
                            LastLoginDate={items?.users?.LastLoginDate}
                            Rating={items?.users?.Profiles?.Rating}
                            Reviews={items?.users?.Profiles?.Review}
                            PictureUrl={items?.users?.Profiles?.PictureUrl}
                          />
                        </Col>
                      );
                    }
                  )
                ) : (
                  <Col
                    xs={24}
                    style={{
                      padding: "10px",
                      textAlign: "left",
                      color: "#7E7E7E",
                      paddingLeft: "23px",
                      fontSize: "16px",
                    }}
                  >
                    You don't have any private candidates yet.
                  </Col>
                )}
              </Row>
            </Cards>
          )}

          {details?.myjobs?.gigs?.length > 0 ? (
            <Cards
              heading={"My gigs"}
              count={
                details?.myjobs?.gigs.length >= 3
                  ? details?.myjobs?.count
                  : details?.myjobs?.gigs.length
              }
              goto={"/joblisting"}
            >
              {windowDimensions.width < 768 ? (
                <Col xs={24} lg={7}>
                  <JobCard
                    img={
                      details?.myjobs?.gigs[0]?.Regions?.Code !== null &&
                      details?.myjobs?.gigs[0]?.Cities?.CityName !== null
                        ? getImageByStateCode(
                            details?.myjobs?.gigs[0]?.Regions?.Code,
                            details?.myjobs?.gigs[0]?.Cities?.CityName,
                            details?.myjobs?.gigs[0]?.CompanyName
                          )
                        : candidate_img
                    }
                    RegionCode={details?.myjobs?.gigs[0]?.Regions?.Code}
                    CityName={details?.myjobs?.gigs[0]?.Cities?.CityName}
                    id={details?.myjobs?.gigs[0]?.JobOrderId}
                    rates={
                      details?.myjobs?.gigs[0]?.BudgetTypes?.BudgetTypeName
                    }
                    budget={
                      details?.myjobs?.gigs[0]?.BudgetMin?.$numberDecimal ??
                      details?.myjobs?.gigs[0]?.BudgetMin
                    }
                    facilityname={details?.myjobs?.gigs[0]?.FacilityName}
                    title={details?.myjobs?.gigs[0]?.Title}
                    matchedbids={details?.myjobs?.gigs[0]?.status[2].count}
                    cardFooter={true}
                    placedbids={details?.myjobs?.gigs[0]?.status[0].count}
                    receivedbids={details?.myjobs?.gigs[0]?.status[1].count}
                    professionCode={userProfile?.Professions?.ProfessionCode}
                    jobOrderId={details?.myjobs?.gigs[0]?.JobOrderId}
                    rating={details?.myjobs?.gigs[0]?.facilityRating?.rating}
                    fromDashboard={true}
                    created={details?.myjobs?.gigs[0]?.Created}
                    isPrivateGig={details?.myjobs?.gigs[0]?.isPrivate || false}
                    ExternalGigId={details?.myjobs?.gigs[0]?.ExternalGigId}
                    showAI={true}
                  />
                </Col>
              ) : (
                <Row style={{ padding: "5px 0px 25px 15px" }}>
                  {details?.myjobs?.gigs.length ? (
                    details?.myjobs?.gigs?.map((items, index) => {
                      return windowDimensions.width > 768 &&
                        index > 2 ? null : (
                        <Col className="jobCard-div" key={index}>
                          <JobCard
                            rates={items?.BudgetTypes?.BudgetTypeName}
                            cardFooter={true}
                            {...items}
                            title={items.Title}
                            screen="My Dashboard"
                            Skills={items?.JobOrders_Skills}
                            experience={items.ExperienceLevelName}
                            receivedbids={items.status[1].count}
                            placedbids={items.status[0].count}
                            budget={items.BudgetMin}
                            facilityname={items.FacilityName}
                            matchedbids={items.status[2].count}
                            IdealContractLengthName={
                              items.IdealContractLengthName
                            }
                            created={items?.Created}
                            id={items?.JobOrderId}
                            location={items.Location?.LocationWithCountry}
                            WorkplacePolicy={items?.WorkplacePolicy}
                            img={
                              // items.Location?.RegionCode !== null &&
                              // items.Location?.CityName !== null
                              //   ? getImageByStateCode(
                              //       items.Location?.RegionCode,
                              //       items.Location?.CityName
                              //     )
                              items?.Regions?.Code !== null &&
                              items?.Cities?.CityName !== null
                                ? getImageByStateCode(
                                    items?.Regions?.Code,
                                    items?.Cities?.CityName,
                                    items?.CompanyName
                                  )
                                : candidate_img
                            }
                            RegionCode={items?.Regions?.Code}
                            CityName={items?.Cities?.CityName}
                            fromDashboard={true}
                            // professionCode={professionCode}
                            professionCode={
                              userProfile?.Professions?.ProfessionCode
                            }
                            rating={items?.facilityRating?.rating}
                            jobdetails={[items]}
                            isPrivateGig={items?.isPrivate || false}
                            showAI={true}
                          />
                        </Col>
                      );
                    })
                  ) : (
                    <Col xs={24}>
                      {" "}
                      <Empty />{" "}
                    </Col>
                  )}
                </Row>
              )}
            </Cards>
          ) : (
            <Col lg={24}>
              <div className="employer-profile-body">
                <div className="employer-profile-body-content">
                  <img className="nojobimage" src={noJobs} />
                  <div className="nojobtext">
                    Create a gig to let candidates know you're hiring!
                  </div>
                  <button
                    className="postajob-btn"
                    onClick={() => history.push("/postjob")}
                  >
                    <span className="postjobbtn_plussign">+</span>
                    <span className="postjobbtn_text">Post a gig</span>
                  </button>
                </div>
              </div>
            </Col>
          )}

          {interviews.interviews?.length ? (
            <Cards
              heading={"Upcoming interviews"}
              count={details?.interviewsCount}
              goto={"/view-interviews"}
            >
              <Row className="interview-cards-row">
                {interviews.interviews?.length ? (
                  interviews.interviews?.map((items, index) => {
                    if (index < 3) {
                      return windowDimensions.width < 769 &&
                        index > 0 ? null : (
                        <Col className="interview-card-container" key={index}>
                          <InterviewCard {...items} />
                        </Col>
                      );
                    }
                  })
                ) : (
                  <Col xs={24} style={{ padding: "10px" }}>
                    {" "}
                    <Empty />{" "}
                  </Col>
                )}
              </Row>
            </Cards>
          ) : null}

          {matches?.matchedtalents?.matches?.length ? (
            <Cards
              heading={"Matched candidates"} // Suggested in My Matches UX design
              // count={details?.matchedtalents?.count}
              count={matches?.matchedtalents?.count}
              goto={"/mymatches"}
            >
              <Row
                className={
                  matches?.matchedtalents?.matches.length > 0 &&
                  "candidate-card-row"
                }
              >
                {matches?.matchedtalents?.matches.length > 0 ? (
                  matches?.matchedtalents?.matches?.map((items, index) => {
                    return windowDimensions.width < 768 && index > 1 ? null : (
                      <Col
                        key={index}
                        className={
                          windowDimensions.width < 768
                            ? "candidate-card-column-mobile"
                            : "candidate-card-column"
                        }
                      >
                        <TalentCards
                          {...items}
                          professionCode={professionCode}
                          data={items}
                          ClientRate={
                            items?.skill_listings?.ClientRate?.$numberDecimal ??
                            items?.skill_listings?.ClientRate ??
                            items?.ClientRate?.$numberDecimal ??
                            items?.ClientRate
                          }
                          users={items?.users}
                          UserName={`${items?.users?.Profiles?.FirstName}' '${items?.users?.Profiles?.LastName}`}
                          title={items?.skill_listings?.Title}
                          Experience={
                            items?.users?.Profiles?.YearsOfExperience
                              ?.YearsOfExperienceName
                          }
                          // LastSuccessfulLoginDate={items?.users?.LastSuccessfulLoginDate}
                          LastLoginDate={items?.users?.LastLoginDate}
                          Rating={items?.users?.Profiles?.Rating}
                          Reviews={items?.users?.Profiles?.Review}
                          PictureUrl={items?.users?.Profiles?.PictureUrl}
                        />
                      </Col>
                    );
                  })
                ) : (
                  <Col xs={24} style={{ padding: "10px" }}>
                    {" "}
                    <Empty />{" "}
                  </Col>
                )}
              </Row>
            </Cards>
          ) : null}

          {details?.favorites?.favorites?.length ? (
            <Cards
              heading={
                windowDimensions.width < 768 ? "My Favorites" : "My favorites"
              }
              count={details?.favorites?.count}
              goto={"/myfavourites"}
            >
              <Row
                className={
                  details?.favorites?.favorites.length > 0 &&
                  "candidate-card-row"
                }
              >
                {details?.favorites?.favorites.length > 0 ? (
                  details?.favorites?.favorites?.map((items, index) => {
                    return windowDimensions.width < 768 && index > 1 ? null : (
                      <Col
                        key={index}
                        className={
                          windowDimensions.width < 768
                            ? "candidate-card-column-mobile"
                            : "candidate-card-column"
                        }
                      >
                        <TalentCards
                          {...items}
                          professionCode={professionCode}
                          data={items}
                          users={items?.users}
                          UserName={`${items?.users?.Profiles?.FirstName}' '${items?.users?.Profiles?.LastName}`}
                          title={items?.Title}
                          ClientRate={
                            items?.skill_listings?.ClientRate?.$numberDecimal ??
                            items?.skill_listings?.ClientRate ??
                            items?.ClientRate?.$numberDecimal ??
                            items?.ClientRate
                          }
                          Experience={
                            items?.users?.Profiles?.YearsOfExperience
                              ?.YearsOfExperienceName
                          }
                          // LastSuccessfulLoginDate={items?.users?.LastSuccessfulLoginDate}
                          LastLoginDate={items?.users?.LastLoginDate}
                          Rating={items?.users?.Profiles?.Rating}
                          Reviews={items?.users?.Profiles?.Review}
                          PictureUrl={items?.users?.Profiles?.PictureUrl}
                        />
                      </Col>
                    );
                  })
                ) : (
                  <Col xs={24} style={{ padding: "10px" }}>
                    {" "}
                    <Empty />{" "}
                  </Col>
                )}
              </Row>
            </Cards>
          ) : null}
          {reminders.length > 0 && (
            <Cards
              heading={"Today's Notes Reminders"}
              count={reminders.length}
              seeAll={true}
            >
              {reminders.map((res, index) => {
                return (
                  <div
                    style={{ marginTop: "2.5%", marginBottom: "2.5%" }}
                    key={index}
                  >
                    <Reminders
                      {...res}
                      res={res}
                      index={index}
                      fromDashboard={true}
                    />
                  </div>
                );
              })}
            </Cards>
          )}
        </div>
      )}
    </>
  );
};

export default EmployerDashboard;
